export default function WhitePaperSection() {
  return (
    <section className="bg-[#0d1117] py-16 px-6">
      <div className="max-w-[1280px] mx-auto">
        <div className="flex flex-col lg:flex-row items-center gap-12">
          {/* Metin */}
          <div className="flex-1">
            <div className="inline-flex items-center gap-2 bg-white/10 text-white text-xs font-semibold px-3 py-1.5 rounded-full mb-6">
              <i className="ri-file-text-line text-[#e8600a]"></i>
              Teknik Belge
            </div>
            <h3 className="text-2xl xl:text-3xl font-bold text-white leading-snug mb-4">
              Flash ve Bellek Süper Döngüsü İçin Mimari Tasarım
            </h3>
            <p className="text-sm text-gray-400 leading-relaxed mb-4">
              Bellek ve flash fiyatları sürekli yükselirken RAM gereksinimlerini nasıl azaltacağınızı, sunucu ömrünü nasıl uzatacağınızı ve altyapı maliyetlerini nasıl düşüreceğinizi öğrenin.
            </p>
            <p className="text-xs text-gray-500 mb-8">
              %171 DRAM Fiyat Artışı &nbsp;|&nbsp; %55–60 NAND Flash Artışı &nbsp;|&nbsp; VergeOS Çözüm Yolu
            </p>
          </div>

          {/* Görsel */}
          <div className="flex-shrink-0 w-48 lg:w-56">
            <img
              src="https://www.verge.io/wp-content/uploads/2026/03/WP-Cover-Architecting-Flash-and-Memory-SC-4.png"
              alt="Flash ve Bellek Süper Döngüsü İçin Mimari Tasarım Teknik Belgesi"
              className="w-full h-auto rounded-lg"
            />
          </div>
        </div>
      </div>
    </section>
  );
}
